// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../common/JQueryView';

export default class CsvImportView extends JQueryView {
  static limitByte = 10485760;
  static errorMessageFormat = 'CSV形式のファイルを選択してください';
  static errorMessageSize = '10MB以下のファイルを選択してください';
  static errorMessageSingleFile = '1ファイルのみ選択してください';

  constructor() {
    super('.simple_form');
    $('#next').prop('disabled', true);
  }

  @on({ event: 'dragenter dragover', selector: '#drop_zone' })
  onEnterDropZone(event: any) {
    event.preventDefault();
  }

  @on({ event: 'dragleave', selector: '#drop_zone' })
  onLeaveDropZone(event: any) {
    event.preventDefault();
  }

  @on({ event: 'drop', selector: '#drop_zone' })
  onDropDropZone(event: any) {
    event.preventDefault();
    $(
      'input[name="company_stock_option_rightholder_csv_import_form[file]"]:file',
    )[0].files = event.originalEvent.dataTransfer.files;
    this.render();
  }

  @on({
    event: 'change',
    selector:
      'input[name="company_stock_option_rightholder_csv_import_form[file]"]:file',
  })
  changeInputFile() {
    this.render();
  }

  @on({
    event: 'click',
    selector: '#delete-file-btn',
  })
  removeFile() {
    $('#company_stock_option_rightholder_csv_import_form_file').val('');
    $('#js-file-container').addClass('invisible');
    $('#next').prop('disabled', true);
  }

  render() {
    const files = $(
      '#company_stock_option_rightholder_csv_import_form_file',
    ).prop('files');

    $('.invalid-feedback').remove();

    const validateResult = this.validate(files);

    if (validateResult.status) {
      const file = files[0];
      $('#filename').text(file.name);
      $('#js-file-container').removeClass('invisible');
      $('#next').prop('disabled', false);
    } else {
      validateResult.errorMessages.forEach(msg => {
        $('.drop-zone-wrapper').after(
          `<small class="invalid-feedback">${msg}</small>`,
        );
      });
      $('#company_stock_option_rightholder_csv_import_form_file').val('');
      $('#js-file-container').addClass('invisible');
      $('#next').prop('disabled', true);
    }
  }

  validate(files: FileList) {
    const errorMessages = [];

    if (files.length > 1) {
      errorMessages.push(CsvImportView.errorMessageSingleFile);
    } else {
      const file = files[0];

      if (file.size > CsvImportView.limitByte) {
        errorMessages.push(CsvImportView.errorMessageSize);
      }

      if (file.type !== 'text/csv') {
        errorMessages.push(CsvImportView.errorMessageFormat);
      }
    }

    return { status: !errorMessages.length, errorMessages };
  }
}
